module.exports = __webpack_public_path__ + "static/media/wellington-martins.18044eb8.jpg";